const _env = process.env.NODE_ENV === 'development' ? process.env : (window as any)._env_;
export const config = {
  environment: _env.REACT_APP_ENVIRONMENT || 'dev',
  appVersion: _env.REACT_APP_VERSION || 'local',
  appName: _env.REACT_APP_NAME || 'truebar-editor',
  commitHash: _env.REACT_APP_COMMIT_HASH || 'tbd',
  backendApiUrl: _env.REACT_APP_BACKEND_URL || 'https://dev-editor-backend.true-bar.si',
  backendWsUrl: _env.REACT_APP_WEBSOCKET_URL || 'wss://dev-editor-backend.true-bar.si/ws',
  keycloakUrl: _env.REACT_APP_KEYCLOAK_URL || 'https://new.dev-keycloak.vitasis.si',
  keycloakAuthReam: _env.REACT_APP_KEYCLOAK_AUTH_REALM || 'truebar',
  keycloakClientId: _env.REACT_APP_KEYCLOAK_CLIENT_ID || 'truebar-editor',
  prepareTranscripts: _env.REACT_APP_PREPARED_TRANSCRIPTS,
  historyRefreshIntervalMs: _env.REACT_APP_HISTORY_REFRESH_INTERVAL_MS || 5000,
  showLogo: _env.REACT_APP_SHOW_LOGO === 'true' ? true : false,
  soniox: _env.REACT_APP_SONIOX || 'SONIOX',
  defaultSummaryModel: _env.REACT_APP_DEFAULT_SUMMARY_MODEL || 'next',
  summaryServiceUrl: _env.REACT_APP_SUMMARY_SERVICE_URL || 'https://llm.true-bar.si',
  summaryDefaultModel: _env.REACT_APP_SUMMARY_DEFAULT_MODEL || 'gpt-5',
  keycloakIdpAlias: _env.REACT_APP_KEYCLOAK_IDP_ALIAS || 'idp',
  publicUrl: _env.REACT_APP_PUBLIC_URL || 'http://localhost:3000/',
};
